import dynamic from 'next/dynamic';

import { SearchHistoryLoading } from './SearchHistory.Loading';

export const DynamicSearchHistory = dynamic(
  () => import(/* webpackChunkName: 'SearchHistory' */ './SearchHistory'),
  {
    loading: () => SearchHistoryLoading(),
    ssr: false,
  },
);

export * from './SearchHistory.Loading';
